import { Api         } from "../api/Api";
import { AerialImage } from "../api/Application";

export interface ImageListLoaderData {
    images: AerialImage[];
    error?: string;
}

export async function imageListLoader(): Promise<ImageListLoaderData> {
    const result = await Api.aerialImageList();
    if( result.isOk ) {
        return { images: result.value };
    } else {
        return {
            images: [], error: result.error || 'Failed to load images'
        };
    }
}